import React from 'react';
import employeeRangeOptions from './employeeRangeOptions';
import {
  useCreateClientAccountScoreSettingEmployeeRangeMutation,
  useDestroyClientAccountScoreSettingEmployeeRangeMutation,
  useAccountScoreSettingQuery,
} from 'api';
import Slider from './Slider';

const Setting = () => {
  const {data: {accountScoreSetting = {}} = {}} = useAccountScoreSettingQuery(
    {},
  );
  const priorities = [1, 2, 3];
  const [create] = useCreateClientAccountScoreSettingEmployeeRangeMutation({});
  const [destroy] = useDestroyClientAccountScoreSettingEmployeeRangeMutation(
    {},
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2 items-start">
        <div className="flex w-full items-center justify-between">
          <div>
            <h2 className="text-base m-0 font-bold">従業員数</h2>
            <p className="m-0 text-sm">
              選択した従業員数の重要度を高めてスコアを算出します。
            </p>
          </div>
          <Slider />
        </div>
        <div className="fix flex-row w-full grid grid-cols-5">
          {priorities.map((priority) => {
            const selected =
              accountScoreSetting?.employeeRangesGroupByPriority?.[
                priority
              ]?.map((employeeRange: any) => employeeRange.enum_value) ?? [];
            return (
              <div className="flex flex-col gap-2" key={priority}>
                <h1 className="text-sm font-bold">優先度{priority}</h1>
                {employeeRangeOptions.map((option, index) => {
                  if (option.value === '0to100' || option.value === 'unknown') {
                    return;
                  }

                  return (
                    <label className="flex items-center text-base" key={index}>
                      <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 rounded border-c-border disabled:bg-c-bg disabled:text-c-light"
                        checked={selected.includes(option.value)}
                        disabled={
                          accountScoreSetting?.employeeRanges?.some(
                            (range) => range.enumValue === option.value,
                          ) && !selected.includes(option.value)
                        }
                        onChange={(e) => {
                          const variables = {
                            employeeRange: option.value,
                            priority,
                          };
                          if (e.target.checked) {
                            create({
                              variables,
                            });
                          } else {
                            destroy({
                              variables,
                            });
                          }
                        }}
                      />
                      <span className="ml-2">{option.label}</span>
                    </label>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Setting;
